import {POLICIES} from "../constants/policies";
import {
  COINS_COLOR_DARK,
  CONSTRUCTIONS_COLOR, CONTROLS_COLOR,
  SUPPLY_COLOR,
  WAR_POLICY_COLOR,
  WIN_POINTS_COLOR_DARK,
} from "../styles/constants";

export const POLICY_MARKET_SIZE = 6;

export const POLICY_CONFIGS = [{
  id: POLICIES.DESPOTISM,
  name: 'Деспотизм',
  description: 'Скидка на найм отрядов\nСкидка на постройку Лагеря',
  implemented: true,
  color: WAR_POLICY_COLOR,
}, {
  id: POLICIES.MILITARISM,
  name: 'Милитаризм',
  description: 'Увеличенный урон в ближнем бою',
  implemented: true,
  color: WAR_POLICY_COLOR,
}, {
  id: POLICIES.INDUSTRIALISM,
  name: 'Индустриализм',
  description: 'Дополнительное действие\nв фазе Строительства\nСкидка на особые строения',
  implemented: true,
  color: CONSTRUCTIONS_COLOR,
}, {
  id: POLICIES.PATRIOTISM,
  name: 'Патриотизм',
  description: 'Скидка на найм размера отрядов и Арсенал',
  implemented: true,
  color: WAR_POLICY_COLOR,
}, {
  id: POLICIES.OLIGARCHY,
  name: 'Олигархия',
  description: '2 гильдий в одном городе\nУвеличенный доход гильдий',
  implemented: true,
  color: COINS_COLOR_DARK,
}, {
  id: POLICIES.HEGEMONISM,
  name: 'Гегемонизм',
  description: 'Бонус к доходу очков и урону в центре поля',
  implemented: true,
  color: WIN_POINTS_COLOR_DARK,
}, {
  id: POLICIES.BARBARISM,
  name: 'Варварство',
  description: 'Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон',
  implemented: true,
  color: WAR_POLICY_COLOR,
}, {
  id: POLICIES.TOTALITARIANISM,
  name: 'Тоталитаризм',
  description: 'Очки за военные строения\nСкидка на Лагерь и Арсенал\nНайм отрядов увеличенного размера',
  implemented: true,
  color: WAR_POLICY_COLOR,
}, {
  id: POLICIES.SERVARIANISM,
  name: 'Серваризм',
  description: 'Увеличенный доход рудников,\nсмежных казармам и крупными отрядам',
  implemented: true,
  color: COINS_COLOR_DARK,
}, {
  id: POLICIES.FORTIFICATIONISM,
  name: 'Фортификационизм',
  description: 'Мгновенное строительство и скидка для крепостей\nБонус к урону рядом с крепостью',
  implemented: true,
  color: CONSTRUCTIONS_COLOR,
}, {
  id: POLICIES.ECOANARCHISM,
  name: 'Экоанархизм',
  description: 'Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля',
  implemented: true,
  color: SUPPLY_COLOR,
}, {
  id: POLICIES.THEOCRACY,
  name: 'Теократия',
  description: 'Увеличенный доход храмов\nБонус к урону отрядов в городе с храмом',
  implemented: true,
  color: WIN_POINTS_COLOR_DARK,
}, {
  id: POLICIES.FANATICISM,
  name: 'Фанатизм',
  description: 'Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты',
  implemented: true,
  color: WIN_POINTS_COLOR_DARK,
}, {
  id: POLICIES.AGRARIANISM,
  name: 'Аграризм',
  description: 'Скидка на Ферму и Склад\nОбмен снабжения на монеты',
  implemented: true,
  color: SUPPLY_COLOR,
}, {
  id: POLICIES.ISOLATIONISM,
  name: 'Изоляционизм',
  description: 'Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах',
  implemented: true,
  color: CONTROLS_COLOR,
}, {
  id: POLICIES.DEMOCRACY,
  name: 'Демократия',
  description: 'Некоторое описание политики',
  implemented: false,
}, {
  id: POLICIES.PACIFISM,
  name: 'Пацифизм',
  description: 'Некоторое описание политики',
  implemented: false,
}, {
  id: POLICIES.LIBERALISM,
  name: 'Либерализм',
  description: 'Некоторое описание политики',
  implemented: false,
}, {
  id: POLICIES.CONSERVATISM,
  name: 'Консерватизм',
  description: 'Некоторое описание политики',
  implemented: false,
}, {
  id: POLICIES.EXPANSIONISM,
  name: 'Экспансионизм',
  description: 'Некоторое описание политики',
  implemented: false,
}, {
  id: POLICIES.NOMADISM,
  name: 'Номадизм',
  description: 'Некоторое описание политики',
  implemented: false,
}, {
  id: POLICIES.MERCANTILISM,
  name: 'Меркантилизм',
  description: 'Некоторое описание политики',
  implemented: false,
}, {
  id: POLICIES.MERITOCRACY,
  name: 'Меритократия',
  description: 'Некоторое описание политики',
  implemented: false,
}, {
  id: POLICIES.DIPLOMATISM,
  name: 'Дипломатизм',
  description: 'Некоторое описание политики',
  implemented: false,
}, {
  id: POLICIES.SECTARIANISM,
  name: 'Сектантство',
  description: 'Некоторое описание политики',
  implemented: false,
}, {
  id: POLICIES.TECHNOCRACY,
  name: 'Технократия',
  description: 'Некоторое описание политики',
  implemented: false,
}]

export const POLICY_CONFIGS_IMPLEMENTED = POLICY_CONFIGS.filter(config => config.implemented);

export const POLICY_IDS_IMPLEMENTED = POLICY_CONFIGS_IMPLEMENTED.map(config => config.id);